import { render, staticRenderFns } from "./ClientContent.vue?vue&type=template&id=0a35262e&scoped=true&"
import script from "./ClientContent.vue?vue&type=script&lang=js&"
export * from "./ClientContent.vue?vue&type=script&lang=js&"
import style0 from "./ClientContent.vue?vue&type=style&index=0&id=0a35262e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a35262e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ichigei/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a35262e')) {
      api.createRecord('0a35262e', component.options)
    } else {
      api.reload('0a35262e', component.options)
    }
    module.hot.accept("./ClientContent.vue?vue&type=template&id=0a35262e&scoped=true&", function () {
      api.rerender('0a35262e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/layouts/Client/ClientContent.vue"
export default component.exports